<template>
    <div>
        <div class="hidden md:flex max-h-[500px]">
            <ul class="flex-column space-y space-y-4 text-sm font-medium md:me-0 mb-4 md:mb-0 w-[30%] overflow-auto">
                <li v-for="(item, index) in schedule" :class="[activeTab == index ? '' : 'mr-4']"
                    @click="changeActiveTab(index)">
                    <div href="#"
                        class="inline-flex items-center px-4 py-3 bg-white dark:bg-neutral-900 dark:bg-opacity-20 dark:backdrop-blur-xl w-full capitalize"
                        :class="[activeTab == index ? 'rounded-l-xl rounded-e-none text-primary dark:!text-gray-200 font-bold  dark:border dark:border-r-0 dark:border-primary' : 'rounded-b-xl  md:rounded-xl dark:text-gray-200']"
                        aria-current="page">
                        {{ getDayName(item.date) }}
                    </div>
                </li>
            </ul>
            <div v-for="(item, index) in schedule"
                class="p-6 bg-white dark:bg-neutral-900 dark:bg-opacity-20 dark:backdrop-blur-xl w-[70%] dark:border dark:border-primary"
                :class="[activeTab == 0 ? 'rounded-b-xl rounded-tr-xl' : 'rounded-xl', activeTab == index ? '' : 'hidden']">
                <h3 class="text-lg font-bold text-gray-800 dark:text-white mb-2 capitalize">{{ getDayName(item.date) }}</h3>
                <div class="mb-2 flex gap-2 flex-wrap w-full mt-4">
                    <div v-for="(item2, index2) in item.items"
                        class="border-gray-800 border-2 rounded-full py-2 px-4 dark:border-gray-200 dark:text-gray-200">
                        {{ getHour(item2.start) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-col md:hidden  max-h-[500px] overflow-auto ">
            <app-accordion v-for="(item, index) in schedule" :key="item.date" class="rounded bg-white dark:bg-neutral-900 dark:bg-opacity-20 dark:backdrop-blur-xl dark:border dark:border-primary w-full px-4 py-6 mb-4" :open="false"
            :class="[activeTab == index ? 'dark:!text-gray-200 font-bold  dark:border dark:border-primary' : 'dark:text-gray-200']">
                <template v-slot:title>
                    {{ getDayName(item.date) }}
                </template>
                <template v-slot:content>
                    <div class="mb-2 flex gap-2 flex-wrap w-full mt-4">
                    <div v-for="(item2, index2) in item.items"
                        class="border-gray-800 border-2 rounded-full py-2 px-4 dark:border-gray-200 dark:text-gray-200">
                        {{ getHour(item2.start) }}
                    </div>
                </div>
                </template>
            </app-accordion>
        </div>
    </div>
</template>
  
<script>
import moment from "moment";
export default {
    data() {
        return {
            schedule: null,
            activeTab: 0,
        }
    },
    mounted() {
        var items = JSON.parse(this.$attrs.items);
        const groups = items.reduce((groups, game) => {
            const date = game.start.split('T')[0];
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(game);
            return groups;
        }, {});

        // Edit: to add it in the array format instead
        const groupArrays = Object.keys(groups).map((date) => {
            return {
                date,
                items: groups[date]
            };
        });

        this.schedule = groupArrays
    },
    methods: {
        parseDateTime(value) {
            if (!isNaN(value) && !_.isObject(value)) {
                let timestamp = Number(value);

                // Convert seconds to milliseconds if 10-digit
                if (timestamp.toString().length === 10) {
                    timestamp *= 1000;
                }

                return moment.utc(timestamp);
            }

            if (_.isString(value)) {
                return moment.utc(
                    value,
                    [
                        moment.ISO_8601,
                        'YYYY-MM-DDTHH:mm:ss.SSSSSSZ',
                        'YYYY-MM-DDTHH:mm:ss.SSSZ',
                        'YYYY-MM-DD HH:mm:ss',
                        'HH:mm:ss'
                    ],
                    true
                );
            }

            return moment.invalid();
        },

        getDayName(date) {
            return this.parseDateTime(date).format('dddd D MMMM');
        },
        getHour(date) {
            return this.parseDateTime(date).format('HH:mm');
        },
        changeActiveTab(index) {
            this.activeTab = index;
        }
    }
};
</script>
  